import { Utils, TLPointerEventHandler } from '@tldraw/core'
import { SessionType } from '@modules/whiteboard'
import {TDShapeType} from '@modules/whiteboard/shapes/types'
import {BaseTool} from '@modules/whiteboard/tools/BaseTool'
import { action } from '@api'

export class ArrowTool extends BaseTool {
  type = 'arrow' as const

  /* ----------------- Event Handlers ----------------- */

  @action onPointerDown: TLPointerEventHandler = () => {
    const {
      currentPoint,
      ui: { currentPageId, currentStyle },
      tools: {startSession}, shapeUtils: {arrow},
      patchCreate
    } = this.app

    const childIndex = this.nextChildIndex

    const id = Utils.uniqueId()

    const newShape = arrow.create({
      id,
      parentId: currentPageId,
      childIndex,
      point: currentPoint,
      style: _.cloneDeep(currentStyle)
    })

    patchCreate([newShape])

    startSession(SessionType.Arrow, newShape.id, 'end', true)

    this.status = 'creating'
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/ArrowTool/ArrowTool.ts